import { Box, Center, ChakraProvider, Flex, Spinner } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes } from "react-router";

import { DEFAULT_QUERY_OPTIONS } from "@nens/react-query-utils";

import { AuthProvider } from "../providers/auth-provider";
import { broTheme } from "../theme/bro-theme";

import { AppRoutes } from "./app-routes";
import { FetchThings } from "./fetch-things";
import { ImportTaskMonitor } from "./import-task-monitor";
import { PublicRoutes } from "./public-routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: DEFAULT_QUERY_OPTIONS,
  },
});

const AppContent = () => {
  return (
    <AuthProvider
      fetchingComponent={
        <Center h="100vh">
          <Spinner size="xl" />
        </Center>
      }
      publicRoutes={<PublicRoutes />}
    >
      <Box minH="100vh">
        <ImportTaskMonitor />
        <FetchThings />
        <Flex flexGrow="1" flexDir="column">
          <AppRoutes />
        </Flex>
      </Box>
    </AuthProvider>
  );
};

export const App = () => {
  return (
    <ChakraProvider theme={broTheme}>
      <QueryClientProvider client={queryClient}>
        <AppContent />
      </QueryClientProvider>
    </ChakraProvider>
  );
};
